<header class="content-header">
  <h4 #trigger class="vision-h4">{{ cloneView ? ('common.actions.clone' | translate) : ''}}
    {{ data.taskRow.taskId }}</h4>
  <fw-popover [trigger]="trigger" position="below" action="mouseenter">
    <div class="padding-15">
      <div class="task-definition" *ngIf="taskDetails; else loadingDetails">
        <strong class="title">{{ 'common.labels.task' | translate }} {{ taskDetails.reader_task.item_number }} /
          {{ taskDetails.reader_task.batch_total_tasks }}</strong>
        <strong>{{ 'taskReviewDialog.labels.containerFilter' | translate }}</strong>
        <div class="tags-group">
          <span>{{ 'taskReviewDialog.labels.containsTags' | translate }}</span>
          <fw-tags *ngIf="taskTagContainers.include.tags.length > 0; else emptyTags" test-id="task-includes-tags"
            [useAsInlineField]="true" [container]="$any(taskTagContainers.include)" [writable]="false">
          </fw-tags>
        </div>
        <div class="tags-group">
          <span>{{ 'taskReviewDialog.labels.notContainsTags' | translate }}</span>
          <fw-tags *ngIf="taskTagContainers.exclude.tags.length > 0; else emptyTags" test-id="task-excludes-tags"
            [useAsInlineField]="true" [container]="$any(taskTagContainers.exclude)" [writable]="false">
          </fw-tags>
        </div>
        <ng-template #emptyTags>
          <span><i>{{ 'common.labels.none' | translate }}</i></span>
        </ng-template>
      </div>
      <ng-template #loadingDetails>
        <span>{{ 'common.labels.loading' | translate }}</span>
      </ng-template>
    </div>
  </fw-popover>
  <span test-id="project-context" class="project-context">
    {{ 'common.labels.project' | translate | titlecase }}: {{ data.taskRow.projectLabel }}
  </span>
  <mat-icon *ngIf='canDownloadFiles' (click)='$event.stopPropagation(); downloadTaskFiles(data.taskRow)'
    [fwTooltip]="'tasks.actions.downloadTask' | translate">cloud_download
  </mat-icon>
  <button *ngIf="!cloneView" test-id="view-task" mat-flat-button color="primary"
    (click)="viewTask()">{{ 'taskReviewDialog.actions.launchInViewer' | translate }}</button>
</header>
<div mat-dialog-content>
  <div class="immutable-details fw-well">
    <div class="detail">
      <span class="title">{{ 'taskReviewDialog.labels.taskType' | translate }}</span>
      <span test-id="task-type" class="detail-value">{{ data.taskRow.taskType }}</span>
    </div>
    <div class="detail">
      <span class="title">{{ 'taskReviewDialog.labels.readProtocol' | translate }}</span>
      <span *ngIf="data.taskRow.protocol; else noProtocol" test-id="read-protocol" class="detail-value"
        [fwTooltip]="data.taskRow.protocol?.description">
        {{ data.taskRow.protocol.label }}
      </span>
      <ng-template #noProtocol>
        <span test-id="no-protocol" class="detail-value">{{ 'taskReviewDialog.labels.noProtocol' | translate }}</span>
      </ng-template>
    </div>
    <div class="detail">
      <span class="title">{{ 'common.labels.container' | translate }}</span>
      <fw-ellipsis test-id="container" class="detail-value" [text]="data.taskRow.container.label || ''"
        [tooltip]="data.taskRow.container.hierarchy">
      </fw-ellipsis>
    </div>
    <div *ngIf="!cloneView" class="detail">
      <span class="title">{{ 'taskReviewDialog.labels.taskCreator' | translate }}</span>
      <span test-id="creator" class="detail-value">
        <ng-container *ngIf="data.taskRow.creator; else unknown">
          <app-avatar [users]="data.taskRow.creator"></app-avatar>
          <span>{{ data.taskRow.creator.firstname }} {{ data.taskRow.creator.lastname }}</span>
        </ng-container>
        <ng-template #unknown>
          <span>{{ 'taskReviewDialog.labels.unknown' | translate }}</span>
        </ng-template>
      </span>
    </div>
  </div>
  <div class="flex-container">
    <form class="editable-details" [formGroup]="formGroup">
      <div class="half-width">
        <label [attr.aria-label]="'common.labels.assignee' | translate">
          {{ 'common.labels.assignee' | translate }}
        </label>
        <div class="mat-form-field">
          <app-typeahead test-id="user-typeahead" class="solid-background full-width" formControlName="assignee"
            [placeholder]="'common.labels.assignee' | translate" [options]="users">
          </app-typeahead>
          <mat-error *ngIf="formGroup.controls.assignee.hasError('required')">
            {{ 'taskReviewDialog.errors.assigneeRequired' | translate }}
          </mat-error>
        </div>
      </div>

      <div class="half-width">
        <label [attr.aria-label]="'taskReviewDialog.labels.dueDate' | translate">
          {{ 'taskReviewDialog.labels.dueDate' | translate }}
        </label>
        <mat-form-field appearance="outline" class="date-field flex-field">
          <input test-id="due-date-input" formControlName="dueDate" matInput [matDatepicker]="datepicker"
            placeholder="{{ 'taskReviewDialog.labels.selectDate' | translate }}" autocomplete="off">
          <mat-datepicker-toggle [for]="datepicker" class="xs" test-id="due-date-toggle">
            <mat-icon matDatepickerToggleIcon class="xs">event</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #datepicker></mat-datepicker>
          <mat-error *ngIf="formGroup.controls.dueDate.hasError('required')">
            {{ 'taskReviewDialog.errors.dueDateRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="formGroup.controls.dueDate.hasError('pastDate')">
            {{ 'taskReviewDialog.errors.dueDatePassed' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="half-width" *ngIf="!cloneView;">
        <label [attr.aria-label]="'common.labels.status' | translate">
          {{ 'common.labels.status' | translate }}
        </label>
        <mat-form-field appearance="outline">
          <mat-select test-id="status" formControlName="status">
            <mat-option *ngFor="let status of statusOptions" [value]="status.value">{{ status.display }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="half-width">
        <label [attr.aria-label]="'taskReviewDialog.labels.taskTags' | translate">
          {{ 'taskReviewDialog.labels.taskTags' | translate }}
        </label>
        <fw-tags test-id="task-tags" formControlName="tags" [autoSave]="false" [allowCustomTags]="true"
          [container]="tagContainer" [useAsInlineField]="true"></fw-tags>
      </div>
    </form>

    <ng-container *ngIf="!cloneView;">
      <mat-tab-group *ngIf="taskDetails; else loadingState" class="tabs-white content-body" animationDuration="0ms" mat-stretch-tabs="false">
        <mat-tab [label]="'taskReviewDialog.labels.formData' | translate">
          <ng-template matTabContent>
            <mat-table *ngIf="formData.data.length; else emptyFormData" [dataSource]="formData" class="data-table">
              <ng-container matColumnDef="question">
                <mat-cell *matCellDef="let element">
                  <strong [attr.test-id]="'question-label-' + element.key">{{ element.label }}</strong>
                  <span [attr.test-id]="'question-key-' + element.key" class="grey">{{ element.key }}</span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="response">
                <mat-cell *matCellDef="let element">
                  <span [attr.test-id]="'response-label-' + element.key" class="response"
                    [innerHTML]="element.response ? element.response : '-'"></span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="error">
                <mat-cell *matCellDef="let element" colspan="2">
                  <strong
                    test-id="form-data-error-header">{{ 'taskReviewDialog.errors.sliceSpecificHeader' | translate }}</strong>
                  <span test-id="form-data-error-message"
                    class="grey">{{ 'taskReviewDialog.errors.sliceSpecificBody' | translate }}</span>
                </mat-cell>
              </ng-container>
              <ng-container *ngIf="!isSliceSpecificWorkflow">
                <mat-row *matRowDef="let element; columns: ['question', 'response']"></mat-row>
              </ng-container>
              <ng-container *ngIf="isSliceSpecificWorkflow">
                <mat-row *matRowDef="let element; columns: ['error']"></mat-row>
              </ng-container>
            </mat-table>
            <ng-template #emptyFormData>
              <div class="empty blank-state">
                <mat-icon class="sm raised blue">search</mat-icon>
                <p>{{ 'taskReviewDialog.labels.formDataEmpty' | translate }}</p>
              </div>
            </ng-template>
          </ng-template>
        </mat-tab>
        <mat-tab [label]="'taskReviewDialog.labels.annotationData' | translate">
          <ng-template matTabContent>
            <mat-table *ngIf="annotationData.data.length; else emptyAnnotations" [dataSource]="annotationData"
              class="data-table">
              <ng-container matColumnDef="question">
                <mat-cell *matCellDef="let element">
                  <strong [attr.test-id]="'question-label-' + element.key">{{ element.label }}</strong>
                  <span [attr.test-id]="'question-key-' + element.key" class="grey">{{ element.key }}</span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="response">
                <mat-cell *matCellDef="let element">
                  <span [attr.test-id]="'response-label-' + element.key"
                    [fwTooltip]="'taskReviewDialog.labels.annotationCountTooltip' | translate" class="response"
                    [innerHTML]="element.response ? element.response : '-'"></span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="error">
                <mat-cell *matCellDef="let element" colspan="2">
                  <strong
                    test-id="annotation-data-error-header">{{ 'taskReviewDialog.errors.sliceSpecificHeaderAnnotation' | translate }}</strong>
                  <span test-id="annotation-data-error-message"
                    class="grey">{{ 'taskReviewDialog.errors.sliceSpecificBody' | translate }}</span>
                </mat-cell>
              </ng-container>
              <ng-container *ngIf="!isSliceSpecificWorkflow">
                <mat-row *matRowDef="let element; columns: ['question', 'response']"></mat-row>
              </ng-container>
              <ng-container *ngIf="isSliceSpecificWorkflow">
                <mat-row *matRowDef="let element; columns: ['error']"></mat-row>
              </ng-container>
            </mat-table>
            <ng-template #emptyAnnotations>
              <div class="empty blank-state">
                <mat-icon class="sm raised blue">search</mat-icon>
                <p>{{ 'taskReviewDialog.labels.annotationDataEmpty' | translate }}</p>
              </div>
            </ng-template>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
      <ng-template #loadingState>
        <div test-id="loading-state" class="blank-state content-body">
          <img src="/assets/images/loading.svg" style="margin-bottom:10px">
          <p>{{ 'taskReviewDialog.labels.loadingDetails' | translate }}</p>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>

<div class="action-buttons" mat-dialog-actions align="end">
  <ng-container *ngIf="!cloneView; else cloneButtons">
    <a test-id="view-related-tasks"
      (click)="viewRelatedTasks()">{{ 'taskReviewDialog.labels.viewRelatedTasks' | translate }}</a>
    <ng-container *ngIf="isReaderTaskAdmin; else closeButton">
      <button test-id="cancel-button" mat-stroked-button
        mat-dialog-close>{{ 'common.actions.cancel' | translate }}</button>
      <button test-id="delete-button" mat-stroked-button
        (click)="deleteTask()">{{ 'common.actions.delete' | translate }}</button>
      <button test-id="clone-button" mat-stroked-button
        (click)="showCloneView(true)">{{ 'common.actions.clone' | translate }}</button>
      <button test-id="save-button" mat-flat-button color="primary" (click)="submit()"
        [disabled]="formGroup.invalid || !formGroup.dirty">
        {{ 'common.actions.saveChanges' | translate }}
      </button>
    </ng-container>
    <ng-template #closeButton>
      <button test-id="close-button" mat-stroked-button
        mat-dialog-close>{{ 'common.actions.close' | translate }}</button>
    </ng-template>
  </ng-container>
  <ng-template #cloneButtons>
    <button test-id="cancel-clone-button" mat-stroked-button
      (click)="showCloneView(false)">{{ 'common.actions.cancel' | translate }}</button>
    <button test-id="clone-button" mat-flat-button color="primary" (click)="createClone()"
      [disabled]="formGroup.invalid">
      {{ 'common.actions.clone' | translate }}
    </button>
  </ng-template>
</div>
